// usePrivacyStore.ts
import { create } from "zustand";

type PrivacyState = {
  isPrivacyModeOn: boolean;
  isPrivacyModeEnabled: boolean;
  setPrivacyModeState: (on: boolean) => void;
  setPrivacyModeEnabled: (enabled: boolean) => void;
};

export const usePrivacyStore = create<PrivacyState>((set) => ({
  isPrivacyModeOn: false,
  isPrivacyModeEnabled: false,
  setPrivacyModeState: (on) => set({ isPrivacyModeOn: on }),
  setPrivacyModeEnabled: (enabled) => set({ isPrivacyModeEnabled: enabled }),
}));
